import {
  GLOBAL_WORKFLOW_ID,
  SavedTreeItem,
  VariableApi,
  VariableGroupApi,
  VariableImportItem,
} from '@selfai-platform/pipeline-common';
import { isGroup, isVariable } from './type-guards.util';

export function mapToVariableImportItem(variablesEntities: SavedTreeItem[]): VariableImportItem[] {
  const topLevelItems = variablesEntities.filter((item) => !item.parentGroupId);

  function buildTree(items: SavedTreeItem[]): VariableImportItem[] {
    return items.map((item) => {
      const children = variablesEntities.filter((child) => child.parentGroupId === item.id);

      const { parentGroupId, workflowId, ...baseItem } = item;

      if (isVariable(item)) {
        return baseItem as VariableApi;
      } else if (isGroup(item)) {
        const groupItem: VariableGroupApi = {
          ...baseItem,
          variables: buildTree(children),
        } as VariableGroupApi;

        return groupItem;
      } else {
        console.error('Invalid item type', item);
        throw new Error();
      }
    });
  }

  return buildTree(topLevelItems);
}

export function normalizeVariablesResponse(
  response: (VariableApi | VariableGroupApi)[],
  currentWorkflowId: string,
): SavedTreeItem[] {
  const items = Array.isArray(response) ? response : [];
  const allNormalizedItems: SavedTreeItem[] = [];

  function normalizeItem(item: VariableApi | VariableGroupApi, parentGroupId?: string): void {
    const normalizedItem: SavedTreeItem = {
      ...item,
      workflowId: item.isGlobal ? GLOBAL_WORKFLOW_ID : currentWorkflowId,
      parentGroupId: parentGroupId,
      ...('variables' in item ? { variables: undefined } : {}),
    };

    allNormalizedItems.push(normalizedItem);

    if ('variables' in item && item.variables) {
      item.variables.forEach((childItem) => {
        normalizeItem(childItem, item.id);
      });
    }
  }

  items.forEach((item) => normalizeItem(item));

  return allNormalizedItems;
}
